import { useState } from 'react';
import { fetchWithCSRF } from '../utils/csrfUtils';
import { useAuth } from '../context/AuthContext';

export const useRefreshSingleMealAndGroceryList = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [error, setError] = useState(null);
  const { sessionToken } = useAuth();

  const refreshSingleMealAndGroceryList = async (mealId, appUserId) => {
    setIsRefreshing(true);
    setError(null);
    
    try {
      if (!sessionToken) {
        throw new Error('No valid session found');
      }

      const response = await fetchWithCSRF('/api/v1/meal/refresh/meal', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionToken}`
        },
        body: JSON.stringify({
          meal_id: mealId,
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to refresh meal');
      }

      const data = await response.json();
      console.log('Meal refreshed successfully:', data);
      return data;
    } catch (err) {
      setError(err.message);
      console.error('Error refreshing meal:', err);
      throw err;
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    refreshSingleMealAndGroceryList,
    isRefreshing,
    error
  };
};

export default useRefreshSingleMealAndGroceryList;
